var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('level-form',{attrs:{"data":_vm.detailInfo},on:{"save":_vm.handleEditSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }